"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function getClassName(className) {
    return (className ? className + " " : '') + "linkblock dark-links clickable";
}
var VideoLink = /** @class */ (function (_super) {
    __extends(VideoLink, _super);
    function VideoLink() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VideoLink.prototype.componentDidMount = function () {
        var predecate = this.props.preventDefaultPredecate;
        if (this.element && predecate) {
            var clickEventListener = function (event) {
                if (predecate(event.target)) {
                    event.preventDefault();
                    event.stopPropagation();
                    return false;
                }
                return true;
            };
            this.element.addEventListener('click', clickEventListener);
        }
        if (this.element) {
            var mousedownEventListener = function (event) {
                event.preventDefault();
                return false;
            };
            this.element.addEventListener('mousedown', mousedownEventListener);
        }
    };
    VideoLink.prototype.render = function () {
        var _this = this;
        var _a = this.props, native = _a.adObj.native, className = _a.className, style = _a.style, dangerouslySetInnerHTML = _a.dangerouslySetInnerHTML, children = _a.children;
        // TODO: Check if we can use noreferrer on the links
        /* eslint-disable react/jsx-no-target-blank */
        return (React.createElement("a", { ref: function (element) { return (_this.element = element); }, href: native.clickUrl, className: getClassName(className), style: style, dangerouslySetInnerHTML: dangerouslySetInnerHTML, target: "_blank", rel: "noopener" }, children));
        /* eslint-enable react/jsx-no-target-blank */
    };
    return VideoLink;
}(React.Component));
exports.default = VideoLink;
